import React, { useEffect, useRef, useState } from 'react';
import GlobeComponent from './Experience/World/Globe.jsx';
import SearchInterfaceComponent from './Experience/UI/SearchInterface.jsx';
import { useConfig } from './Experience/Utils/ConfigContext';
import './style.css'
import { createTheme, ThemeProvider } from '@mui/material';

const App = () => {
  const config = useConfig();
  const [globeData, setGlobeData] = useState([]);
  const [highlightedCoin, setHighlightedCoin] = useState(null);
  const [trackData, setTrackData] = useState(null);
  const globeRef = useRef(null);
  const starBackgroundRef = useRef(null);

  const [dataLoading, setDataLoading] = useState(true);

  const fetchGlobeData = async () => {
    setDataLoading(true);
    try {
      const response = await fetch(config.getApiUrl('/api/globe-data'));
      const data = await response.json();
      if (data && data.data) {
        setGlobeData(data.data);
        return data.data;
      } else {
      }
    } catch (error) {
      console.error('Error fetching globe data:', error);
    } finally {
      setDataLoading(false);
    }
    return null;
  };

  useEffect(() => {
    fetchGlobeData();
  }, [config]);

  const getCoinHistory = (rsid) => {
    fetch(config.getApiUrl(`/api/coin_tracks/${rsid}`))
      .then(response => response.json())
      .then(data => {
        if (data.success && data.data && data.data.length > 0) {
          const trackPoints = data.data.map(point => ({
            id: point.rsid,
            coinid: point.coinid,
            timestamp: point.timestamp,
            name: point.name,
            location: point.location,
            details: point.details,
            q1: point.q1,
            q2: point.q2,
            latitude: parseFloat(point.geo_lat),
            longitude: parseFloat(point.geo_lng),
            altitude: 0.01,
            radius: 0.1,
            color: '#FF5733'
          }));

          if (trackPoints.length > 0) {
            const latestPoint = trackPoints[trackPoints.length - 1];
            setHighlightedCoin(latestPoint);
            setTrackData(trackPoints);

            if (globeRef.current) {
              globeRef.current.highlightCoin(latestPoint);
            }
          }
        }
      })
      .catch(error => {
        console.error('Error fetching coin history:', error);
      });
  };

  const handleCoinSelected = (rsid) => {
    getCoinHistory(rsid);
  };

  const updateCameraPosition = (position) => {
    if (starBackgroundRef.current) {
      starBackgroundRef.current.updateCameraPosition(position);
    }
  };

  const handleCoinLocationFound = (latitude, longitude) => {
    if (globeRef.current) {
      globeRef.current.animateCameraToPosition(latitude, longitude);
    }
  };

  const theme = createTheme({
    palette: {
      primary: {
        main: '#f5756c'
      }
    }
  })


  return (
    <>
      <ThemeProvider theme={theme}>
        <GlobeComponent
          ref={globeRef}
          pointsData={globeData}
          highlightedCoin={highlightedCoin}
          trackData={trackData}
          updateCameraPosition={updateCameraPosition}
          config={config}
          backgroundControls={starBackgroundRef}
          dataLoading={dataLoading}
        />
        <SearchInterfaceComponent
          onCoinSelected={handleCoinSelected}
          refreshGlobeData={fetchGlobeData}
          onCoinLocationFound={handleCoinLocationFound}
        />
      </ThemeProvider>
    </>
  );
};

export default App;
